export default function (num) {
    const error = "电话号码好像不太对哦";
    if (num < 1000000) {
        return error;
    }
}